import * as core from '../../../../../../../core'

import { query } from './asset-tracker.query'

export const RESOURCE = {
  payload: {
    alias: 'asset.tracker',
    description:
      'Table to explore AI Enabled Assets across Attain organizations',
    name: 'Asset Tracker',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
